import { render, staticRenderFns } from "./FilterConfigurations.vue?vue&type=template&id=15a404b8"
import script from "./FilterConfigurations.vue?vue&type=script&lang=js"
export * from "./FilterConfigurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports